import { render, staticRenderFns } from "./SalaAtendimentoHai.vue?vue&type=template&id=e6829642&scoped=true&"
import script from "./SalaAtendimentoHai.vue?vue&type=script&lang=js&"
export * from "./SalaAtendimentoHai.vue?vue&type=script&lang=js&"
import style0 from "./SalaAtendimentoHai.vue?vue&type=style&index=0&id=e6829642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6829642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VSkeletonLoader})
